module.exports = __webpack_public_path__ + "img/pakistan.a80e0847.svg";